import { CustomError } from "@skv/core";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { RootState, useThunkDispatch } from "../";

import { fetchOpportunity } from "./actions";

export const useOpportunity = (id: string) => {
  const dispatch = useThunkDispatch();
  const opportunityState = useSelector((state: RootState) => state.opportunity);

  const opportunity = id !== "-1" ? opportunityState.data[id] : null;

  useEffect(() => {
    if (!opportunity && id !== "-1") {
      dispatch(fetchOpportunity(id));
    }
  }, [id, opportunity, dispatch]);

  if (opportunity instanceof CustomError) {
    return {
      ...opportunityState,
      loading: false,
      error: opportunity,
      data: null,
    };
  }

  return {
    ...opportunityState,
    data: opportunity,
  };
};
